import { render, staticRenderFns } from "./PhotoActionItem.vue?vue&type=template&id=7c70f84d&"
import script from "./PhotoActionItem.vue?vue&type=script&lang=js&"
export * from "./PhotoActionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports